import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTwitter,
  faFacebook,
  faInstagram,
  faLinkedin,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import ScrollToTop from "./components/scroll/scroll.component";
import { GlobalProvider } from "./data/global-context.context";

// Import and initialize AOS
import AOS from "aos";
import "aos/dist/aos.css";

// Initialize AOS
AOS.init({
  duration: 1000,
  once: false,
  offset: 100,
});

library.add(faTwitter, faFacebook, faInstagram, faLinkedin, faWhatsapp);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <GlobalProvider>
        <ScrollToTop>
          <App />
        </ScrollToTop>
      </GlobalProvider>
    </BrowserRouter>
  </React.StrictMode>,
);

reportWebVitals();

// import React from "react";
// import ReactDOM from "react-dom/client";
// import { BrowserRouter } from "react-router-dom";
// import { library } from "@fortawesome/fontawesome-svg-core";
// import {
//   faTwitter,
//   faFacebook,
//   faInstagram,
//   faLinkedin,
//   faWhatsapp,
//   faWhatsappSquare,
// } from "@fortawesome/free-brands-svg-icons";

// import "./index.css";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import ScrollToTop from "./components/scroll/scroll.component";
// import { GlobalProvider } from "./data/global-context.context";
// // import store from "./store/store";
// // import { Provider } from "react-redux";

// library.add(faTwitter, faFacebook, faInstagram, faLinkedin, faWhatsapp);

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <BrowserRouter>
//       {/* <Provider store={store}> */}
//       <GlobalProvider>
//         <ScrollToTop>
//           <App />
//         </ScrollToTop>
//       </GlobalProvider>
//       {/* </Provider> */}
//     </BrowserRouter>
//   </React.StrictMode>
// );

// // If you want to start measuring performance in your app, pass a function
// // to log results (for example: reportWebVitals(console.log))
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
